import { promotions } from '@/mocks/home';

export default function Promotions() {
  return (
    <section id="promotions" className="w-full py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">福利活动</h2>
          <p className="text-foreground-600 text-sm md:text-base">丰厚福利不间断，多重豪礼等你来拿</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 max-w-6xl mx-auto">
          {promotions.map((promo) => (
            <div
              key={promo.id}
              className="group rounded-xl bg-background-50 border border-background-200/70 p-5 md:p-6 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center mb-4 ${
                promo.color === 'primary' ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-600'
              }`}>
                <i className={`${promo.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-1">{promo.title}</h3>
              <p className={`text-xs md:text-sm font-medium mb-2 ${
                promo.color === 'primary' ? 'text-primary-600' : 'text-accent-600'
              }`}>
                {promo.subtitle}
              </p>
              <p className="text-foreground-600 text-xs leading-relaxed">{promo.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="#"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即参与活动
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}